import { rem } from 'polished'
import React from 'react'
import styled from 'styled-components'

import Divider from './Divider'
import LocationAndDateTime from './LocationAndDateTime'
import LocationWithMap from './LocationWithMap'
import StartAndEndDateTime from './StartAndEndDateTime'

import type { ThingToDoItem } from 'tripPlanner/types/tripItem'
import { isSamePlace } from 'tripPlanner/utils/places'

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${rem(20)};
`

type Props = {
  item: ThingToDoItem
}

function StartAndEndPlaces({ item }: Props) {
  if (isSamePlace(item.startPlace, item.endPlace)) {
    return (
      <Wrapper>
        <LocationWithMap place={item.startPlace} />
        <StartAndEndDateTime startTitle="Start" endTitle="End" item={item} />
      </Wrapper>
    )
  }
  return (
    <>
      <Divider />
      <LocationAndDateTime
        place={item.startPlace}
        placeLabel="Start"
        date={item.startDate}
        time={item.startTime}
        day={item.startDay}
      />
      <Divider />
      <LocationAndDateTime
        place={item.endPlace}
        placeLabel="End"
        date={item.endDate}
        time={item.endTime}
        day={item.startDay}
      />
    </>
  )
}

export default StartAndEndPlaces
